export default __webpack_public_path__ + "static/media/full-image-1.908d2cc7.jpg";